module.exports = __webpack_public_path__ + "static/media/nurse.22ffbd75.svg";